import { shallowEqual, useSelector } from 'react-redux';

import { NsContent } from 'components/common/ns-content/NsContent';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsEmailInput } from 'components/common/ns-email-input/NsEmailInput';
import { useNavigation } from 'hooks/useNavigation';

import {
  setInitialState,
  selectEmail,
  selectIsLoading,
  setEmail,
  selectErrors,
  slice as emailCaptureSlice
} from 'state/email-capture/email-capture-slice';

import { useMaskPII } from 'hooks/useMaskPII';
import { useValidateEmailThunk } from 'hooks/useEmailValidationThunk';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { useAppDispatch } from 'hooks/useAppDispatch.js';
import { Error } from '../../common/error/Error.js';

export const testId = 'emailCaptureEntryTestId';

export const EmailCapture = () => {
  const { eventTypes, next } = useNavigation();
  const dispatch = useAppDispatch();
  const { mask } = useMaskPII();

  const email = useSelector(selectEmail, shallowEqual);
  const isLoading = useSelector(selectIsLoading, shallowEqual);
  const apiErrors = useSelector(selectErrors, shallowEqual);
  const validateEmailThunk = useValidateEmailThunk(emailCaptureSlice);

  const handleChange = (event) => {
    const { value } = event.target;
    dispatch(setEmail(value));
  };

  const handleGoNext = async (e) => {
    e.preventDefault();

    try {
      await dispatch(validateEmailThunk(email));
      next({ eventType: eventTypes.NEXT });
    } catch (e) {
      e && console.error(e);
    }
  };

  const handleSkip = () => {
    dispatch(setInitialState());
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Choose a tariff at a time that suits you" />
        <p>
          We can send your tariff options straight to your inbox so you can go
          through them anytime. Simply fill in the box below.
        </p>
      </NsContent>
      <NsContent>
        <NsForm onSubmit={handleGoNext}>
          <NsEmailInput
            id="email"
            name="email"
            label="Email"
            value={email}
            onChange={handleChange}
            inputAttributes={mask}
          />
          <Error errors={apiErrors} />
          <NsPrimaryCta isLoading={isLoading}>Email me</NsPrimaryCta>
        </NsForm>
        <NsSecondaryCta type="text" onClick={handleSkip}>
          No thanks, just browsing – take me to the tariffs
        </NsSecondaryCta>
        <p>
          If you choose to share your email, we&apos;ll only use it to send your
          tariff options. You won&apos;t receive anything else unless you agree
          to it.
        </p>
      </NsContent>
    </NsPanel>
  );
};

export default EmailCapture;
